var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "form-check" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.detail.no_use.value,
            expression: "detail.no_use.value",
          },
        ],
        staticClass: "form-check-input",
        attrs: { type: "checkbox", id: "ch1" },
        domProps: {
          checked: Array.isArray(_vm.detail.no_use.value)
            ? _vm._i(_vm.detail.no_use.value, null) > -1
            : _vm.detail.no_use.value,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.detail.no_use.value,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(_vm.detail.no_use, "value", $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.detail.no_use,
                    "value",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.detail.no_use, "value", $$c)
            }
          },
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "form-check-label", attrs: { for: "ch1" } }, [
        _vm._v("Безрецептурный (ОТС)"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "" } }, [_vm._v("Название на латыни")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.detail.lt_title.value,
                expression: "detail.lt_title.value",
              },
            ],
            staticClass: "form-control",
            attrs: { disabled: !!_vm.detail.no_use.value, type: "text" },
            domProps: { value: _vm.detail.lt_title.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.detail.lt_title, "value", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "" } }, [_vm._v("Применение (Signa)")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.detail.signa.value,
                expression: "detail.signa.value",
              },
            ],
            staticClass: "form-control",
            attrs: { disabled: !!_vm.detail.no_use.value, type: "text" },
            domProps: { value: _vm.detail.signa.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.detail.signa, "value", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "" } }, [_vm._v("Кол. уп. в рецепте")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.detail.pack.value,
                expression: "detail.pack.value",
              },
            ],
            staticClass: "form-control",
            attrs: { disabled: !!_vm.detail.no_use.value, type: "text" },
            domProps: { value: _vm.detail.pack.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.detail.pack, "value", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "" } }, [
            _vm._v("На сколько дней рецепт"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.detail.days.value,
                expression: "detail.days.value",
              },
            ],
            staticClass: "form-control",
            attrs: { disabled: !!_vm.detail.no_use.value, type: "text" },
            domProps: { value: _vm.detail.days.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.detail.days, "value", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }